 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import PAGE01_COVER from '@/components/page01_cover'
 import PAGE02_INSCOVER from '@/components/page02_inscover'
 import LOVE_1 from '@/components/love_1'
 import PAGE03_COPYRIGHT from '@/components/page03_copyright'
 import PAGE04_TOC from '@/components/page04_toc'
 import PAGE05_INTRO from '@/components/page05_intro'
 import PAGE06_FASHION from '@/components/page06_fashion'
 import PAGE07_TOM from '@/components/page07_tom'
 import PAGE08_GLOBAL from '@/components/page08_global'
 import PAGE09_THRILL from '@/components/page09_thrill'
 import PAGE10_SPECIAL from '@/components/page10_special'
 import LOVE_2 from '@/components/love_2'
 import PAGE11_ABBR from '@/components/page11_abbr'
 import PAGE12_SOURCES from '@/components/page12_sources'
 import PAGE13_BIBLIO from '@/components/page13_biblio'
 import PAGE14_ACK from '@/components/page14_ack'
 import PAGE15_INDEX from '@/components/page15_index'
 import PAGE16_AUTHOR from '@/components/page16_author'
 import BACKCOVER from '@/components/backcover'
 import ABRAMS_STANDALONEBACKAD from '@/components/Abrams_StandaloneBackad'
 import OR_STANDALONEBACKAD from '@/components/OR_StandaloneBackad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/page04_toc",
 			"name" : "page04_toc",
 			"component" : PAGE04_TOC
 		},
 		{
 			"path" : "/page05_intro",
 			"name" : "page05_intro",
 			"component" : PAGE05_INTRO
 		},
 		{
 			"path" : "/page06_fashion",
 			"name" : "page06_fashion",
 			"component" : PAGE06_FASHION
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js